'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var FilterText = function (_React$Component) {
  _inherits(FilterText, _React$Component);
  function FilterText() {
    _classCallCheck(this, FilterText);
    return _possibleConstructorReturn(this, (FilterText.__proto__ || Object.getPrototypeOf(FilterText)).apply(this, arguments));
  }
  _createClass(FilterText, [{
    key: 'handleChange',
    value: function handleChange(event) {
      if (event.target.value === '') {
        this.props.filter.remove(this.props.attribute);
      } else {
        this.props.filter.update(this.props.attribute, event.target.value);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      if (!this.props.label && !this.props.ariaHelp) {
        console.error('For accessibility purposes you must define either the label or ariaHelp prop.'); // eslint-disable-line
      }
      return _react2.default.createElement('div', {
        className: this.props.className
      }, this.props.label ? _react2.default.createElement('label', {
        htmlFor: 'filter-text-' + this.props.attribute
      }, this.props.label) : null, _react2.default.createElement('input', {
        onChange: function onChange(event) {
          _this2.handleChange(event);
        },
        id: 'filter-text-' + this.props.attribute,
        type: 'text',
        'aria-describedby': 'filter-text-' + this.props.attribute + '-help'
      }), this.props.ariaHelp ? _react2.default.createElement('span', {
        className: 'filter__aria-help',
        id: 'filter-text-' + this.props.attribute + '-help'
      }, this.props.ariaHelp) : null);
    }
  }]);
  return FilterText;
}(_react2.default.Component);
FilterText.defaultProps = {
  className: 'filter__text',
  label: '',
  ariaHelp: ''
};
FilterText.propTypes = {
  ariaHelp: _propTypes2.default.string,
  attribute: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  label: _propTypes2.default.string,
  filter: _propTypes2.default.node.isRequired
};
exports.default = FilterText;